import type { View } from "../types";

export type AppRoute =
  | { view: Exclude<View, "reader" | "public-reader" | "universe"> }
  | { view: "universe"; world?: string }
  | { view: "reader"; id: string }
  | { view: "public-reader"; id: string; legacy?: boolean };

const VIEW_PATHS: Partial<Record<View, string>> = {
  studio: "/create",
  feed: "/",
  universe: "/universe",
  library: "/library",
  wallet: "/wallet",
  admin: "/admin",
};

export function pathForView(view: View) {
  return VIEW_PATHS[view];
}

export function publicStoryPath(slug: string) {
  return `/stories/${encodeURIComponent(slug)}`;
}

export function libraryStoryPath(id: string) {
  return `/library/${encodeURIComponent(id)}`;
}

export function worldPath(id: string) {
  return `/universe/${encodeURIComponent(id)}`;
}

function decodeSegment(value: string) {
  try { return decodeURIComponent(value); } catch { return value; }
}

export function routeFromUrl(pathname: string, search = ""): AppRoute {
  const publicMatch = pathname.match(/^\/stories\/([^/]+)\/?$/);
  if (publicMatch) return { view: "public-reader", id: decodeSegment(publicMatch[1]) };
  const libraryMatch = pathname.match(/^\/library\/([^/]+)\/?$/);
  if (libraryMatch) return { view: "reader", id: decodeSegment(libraryMatch[1]) };
  const worldMatch = pathname.match(/^\/universe\/([^/]+)\/?$/);
  if (worldMatch) return { view: "universe", world: decodeSegment(worldMatch[1]) };
  const legacyStory = new URLSearchParams(search).get("story");
  if (legacyStory) return { view: "public-reader", id: legacyStory, legacy: true };
  if (pathname.replace(/\/$/, "") === "/feed") return { view: "feed" };
  const matched = Object.entries(VIEW_PATHS).find(([, path]) => path === pathname.replace(/\/$/, "") || (path === "/" && pathname === "/"));
  return { view: (matched?.[0] as Exclude<View, "reader" | "public-reader"> | undefined) || "feed" };
}
